import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import web3Config from "@Web3WalletConfig/config";
export default {
  name: "index",
  computed: {
    ...walletVuex.mapState(["theme"]),
    web3Config() {
      return web3Config;
    }
  },
  methods: {
    preventDefault() {
      this.$nextTick(() => {
        const center = document.querySelector("._indexPage");
        if (!center) return;
        console.log("center", center);
        center.addEventListener("touchmove", function (event) {
          event.preventDefault();
        }, {
          passive: false
        });
      });
    }
  },
  mounted() {
    this.preventDefault();
  }
};